export default {
	putCurrentMonth(context, payload) {
		context.commit('PUT_CURRENT_MONTH', payload);
	}, putMonthList(context, payload) {
		context.commit('PUT_MONTH_LIST', payload);
	}
};



// WEBPACK FOOTER //
// ./sources/components/calendar/month/actions.js